<template>
  <v-btn
    v-show="mostrarIrTopo"
    data-cy="button_ir_topo"
    :width="width"
    color="primary"
    dark
    text
    @click="$vuetify.goTo(0)"
  >
    Ir para o topo
  </v-btn>
</template>

<script>
export default {
  name: 'BtnIrTopo',

  props: {
    show: {
      type: Boolean,
      required: true,
    },
    width: {
      type: String,
      default: 'auto',
    },
  },

  computed: {
    mostrarIrTopo: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      },
    },
  },

  mounted() {
    window.addEventListener('scroll', this.onScroll);
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },

  methods: {
    onScroll() {
      this.mostrarIrTopo = window.pageYOffset > 0;
    },
  },
};
</script>
